export const NOTIFICATION_ACCESSORS = {
  SMS: "AUTH_DONNEES_PERSO",
  EMAIL: "AUTH_NOTIFICATIONS",
};
